import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-linked-item-error-dialog',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog
      header="Törlés megerősítése"
      [visible]="visible"
      (visibleChange)="visibleChange.emit($event)"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <div style="display: flex; flex-direction: column; gap: 1rem; padding: 1rem 0">
        <p>{{ message }}</p>
      </div>
      <ng-template pTemplate="footer">
        <p-button label="MÉGSEM" severity="secondary" [text]="true" (onClick)="visibleChange.emit(false)" />
      </ng-template>
    </p-dialog>
  `,
})
export class LinkedItemErrorDialog {
  @Input() visible = false;
  @Input() message = '';
  @Output() visibleChange = new EventEmitter<boolean>();
}
